/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { object, func } from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { SIGNUP_STATUS } from 'reducers/user';

import { approveProfile as approveProfileAction } from 'actions/user';

/**
 * This is the ApproveProfileButton component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class ApproveProfileButton extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    user: object.isRequired,
    auth: object.isRequired,
    approveProfile: func.isRequired,
  };

  onClick = () => {
    const {
      auth: { token },
      approveProfile,
    } = this.props;

    approveProfile(token);

    alert('PROFILE APPROVED. PLEASE RELOAD');
  };

  /**
   * Render ApproveProfileButton.
   *
   * @return {Object}
   */
  render() {
    const {
      user,
      auth: { isAuthenticated },
    } = this.props;

    const show =
      isAuthenticated && user.status !== SIGNUP_STATUS.APPLICATION_APPROVED;

    return (
      show && (
        <button style={{ borderColor: 'DodgerBlue' }} onClick={this.onClick}>
          APPROVE PROFILE
        </button>
      )
    );
  }
}

export default withRouter(
  connect(
    ({ user, auth }) => ({ user, auth }),
    {
      approveProfile: approveProfileAction,
    }
  )(ApproveProfileButton)
);
